import './static/css/compiled-tailwind.min.css';